import { useState } from "react";

import { Button, Modal, Table, TableTitleLayout, Tag } from "@shared/ui";

import { PlusOutlined } from "@ant-design/icons";
import { useGetBuckets } from "@entities/bucket/lib/hooks/useGetBuckets";
import BucketCategoryFilter from "@entities/bucket/ui/BucketCategoryFilter";
import BucketForm from "@entities/bucket/ui/BucketForm";
import { IBucket } from "@shared/lib/types/influencer";
import { SelectedFilters } from "@shared/ui/filters/SelectedFilters";
import RangeSlider from "@shared/ui/slider/RangeSlider";
import { Divider, Flex, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "use-debounce";
import ColumnFilterWrapper from "@shared/ui/filters/ColumnFilterWrapper/ColumnFilterWrapper";
import styles from "./styles.module.scss";

export function BucketPage() {
  const [paegNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery,setsearchQuery] = useState("");
  const [minInfluencerCount, setMinInfluencerCount] = useState<number>(0);
  const [debouncedSearchQuery] = useDebounce(searchQuery, 1000);
  const [selectedCategory, setSelectedCategory] = useState<string[]>([]);
  const navigate = useNavigate();


  const [isModalVisible, setModalVisible] = useState(false);

  const {buckets,isFetching,totaldata} = useGetBuckets({
    pageNo:paegNo,
    limit:pageSize,
    searchQuery:debouncedSearchQuery,
    minInfluencerCount:minInfluencerCount,
    categories:selectedCategory
  });
  const handlePaginationChange = (page: number, size: number) => {
    setPageNo(page);
    setPageSize(size);
  };



  const handleSearchChange = (val: string) => {
     setsearchQuery(val);
  };


  const columns: ColumnsType<IBucket> = [
    {
      title: "Name",
      dataIndex: "username",
      key: "name",
      render: (_: string, record: IBucket) => (
            <div className={styles.name} style={{ cursor: "pointer" }} onClick={()=>{
              navigate(`/bucket/${record.bucketId}`);
            }} > {record?.name}</div>
      ),
    },
    {
      title: "Campaign",
      dataIndex: "campaign",
      key: "campaign",
      render: (_: string, record: IBucket) => (
            <div className={styles.grid}> {record?.campaign || "Fitness Influencers"}</div>
      ),
    },

    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      filterCount: selectedCategory.length,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return <BucketCategoryFilter selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}  onConfirm={props.confirm} onClose={props.close} />;
      },
      render: (_: string, record: IBucket) => (
        record.category.map((item)=>{
          return <Tag key={item} color={"gray"}>{item}</Tag>
        }))
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (_: string, record: IBucket) => (
            <div className={styles.grid}> {record?.description}</div>
      ),
    },

      {
        title: "Influencer Count",
        dataIndex: "searchV1.influencercount",
        key: "influencercount",
        filterCount: minInfluencerCount > 0 ? 1 : 0,
        filterDropdownProps: { destroyPopupOnHide: true },
        filterDropdown: (props: { confirm: () => void; close: () => void }) => {
          const FilterDropdownContent = () => {
            const [minimum, setminimum] = useState<number>(minInfluencerCount);
  
            return (
              <ColumnFilterWrapper
                title="Influencer Count"
                filterCount={minimum > 0 ? 1 : 0}
                isFiltered={minimum > 0}
                onReset={() => {
                  setminimum(0);
                  setMinInfluencerCount(0);
                  props.confirm();
                }}
                onApply={() => {
                  setMinInfluencerCount(minimum);
                  props.confirm();
                }}
                onClose={props.close}
              >
                <div style={{ padding: "8px 4px" }}>
                  <RangeSlider
                    title="Set Influencer Count Per Bucket"
                    minvalue={0}
                    maxvalue={100}
                    value={minimum}
                    onchange={(value: number) => setminimum(value)}
                    showselectedvalue={true}
                  />
                </div>
              </ColumnFilterWrapper>
            );
          };
  
          return <FilterDropdownContent />;
        },
        render: (_: string, record: IBucket) => (
          <Tag color={"gray"}>{record?.socialMediaNames.length}</Tag>
        ),
      },
  ];

return (
    <div>
      <h1 className={styles.title}>Buckets</h1>

        
        <Table
          columns={columns}
          title={() => <TableTitleLayout 
          filterComponent={
          <div style={{width: "100%"}}>
            <Flex justify="space-between" style={{width: "100%"}}>
            <Input
              placeholder="Search by bucket name or influencer name"
              value={searchQuery}
              onChange={(e) => {
                handleSearchChange(e.target.value);
              }}
              allowClear
              style={{ width: 350 }}
              prefix={<Search size={14}/>}
            />
            <Button icon={<PlusOutlined />} type="primary" disabled={false} onClick={() =>setModalVisible(true)}>
                    Create Bucket
            </Button>
          </Flex>
          <SelectedFilters filters={
          {
            "category":{
              keyvalue:selectedCategory,
              clearHandler:()=>setSelectedCategory([])
            }
          }
        }/>
          </div>}
          totalText={`${totaldata || 0} Records found`}
          />}
          loading={isFetching}
          dataSource={buckets}
          pagination={{
            current: paegNo,
            pageSize: pageSize,
            total: totaldata,
            onChange: handlePaginationChange,
          }}
        />
      <Modal
        title={"Create Bucket"}
        open={isModalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose>
          <Divider style={{marginTop:10}}/>
        <BucketForm closeModal={()=>setModalVisible(false)}/>
      </Modal>
    </div>
  );
}